import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialActivationButtonWithTooltip = ({
  use,
  upgradeProduct,
  onClick,
  isTrialed,
  showActivationModalContainer,
  isLoading,
  trialI18nKey,
  propsToPass,
  children
}) => {
  const resultIcon = showActivationModalContainer ? 'success' : null;
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !isTrialed,
    placement: "bottom",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.trialActivationButton.tooltip.disabledButton",
      options: {
        upgradeProduct: I18n.text(`upgrades.products.${upgradeProduct}`)
      }
    }),
    children: propsToPass.use && propsToPass.use.includes('link') ? /*#__PURE__*/_jsx(UIButton, Object.assign({}, propsToPass, {
      use: use,
      onClick: onClick,
      "data-selenium": "trial-button",
      "data-test-id": "trial-button",
      "data-reagan-primary-cta": true,
      disabled: isTrialed,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: trialI18nKey
      })
    })) : /*#__PURE__*/_jsx(UILoadingButton, Object.assign({}, propsToPass, {
      use: use,
      onClick: onClick,
      "data-selenium": "trial-button",
      "data-test-id": "trial-loading-button",
      "data-reagan-primary-cta": true,
      loading: showActivationModalContainer || isLoading,
      disabled: isTrialed,
      resultIcon: resultIcon,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: trialI18nKey
      })
    }))
  });
};
export default TrialActivationButtonWithTooltip;